import React from 'react';
import { Link } from 'react-router-dom';
import { siteConfig, navigation } from '../../data/mock';

const Footer = () => {
  return (
    <footer className="bg-[#070D19] py-20 border-t border-white/5">
      <div className="l-container">
        <div className="flex flex-col md:flex-row justify-between items-start gap-16">
          {/* Logo & Address */}
          <div className="flex flex-col items-start">
            <Link to="/" className="block mb-8">
              <img 
                src="/images/qasaba-logo-full.png" 
                alt={siteConfig.name}
                className="h-48 w-auto"
              />
            </Link>
            <address className="not-italic text-white/50 text-sm leading-loose">
              {siteConfig.address.line1}<br />
              {siteConfig.address.line2}<br />
              {siteConfig.address.city}<br />
              {siteConfig.address.country}
            </address>
          </div>

          {/* Navigation */}
          <nav className="flex flex-wrap gap-8">
            {navigation.map((item) => (
              <Link
                key={item.name}
                to={item.path}
                className="text-sm text-white/50 hover:text-[#4ECDC4] transition-colors"
              >
                {item.name}
              </Link>
            ))}
            <a
              href={`mailto:${siteConfig.email}`}
              className="text-sm text-white/50 hover:text-[#4ECDC4] transition-colors"
            >
              Contact
            </a>
          </nav>
        </div>

        <div className="mt-16 pt-8 border-t border-white/5">
          <p className="text-white/30 text-xs">
            © {new Date().getFullYear()} {siteConfig.name}. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
